import type { ReactNode } from "react";
import { Box, Button, Grid, InputAdornment, TextField } from "@mui/material";
import { Search } from "lucide-react";

export type ListPageFilterField = {
  label: string;
  placeholder?: string;
};

interface ListPageCardShellProps {
  searchPlaceholder: string;
  addButtonLabel?: string;
  gridHeight?: number;
  filterFields?: ListPageFilterField[];
  children: ReactNode;
}

export default function ListPageCardShell({
  searchPlaceholder,
  addButtonLabel,
  gridHeight = 500,
  filterFields,
  children,
}: ListPageCardShellProps) {
  return (
    <div className="card custom-card card-padding">
      {filterFields && filterFields.length > 0 ? (
        <Box sx={{ mb: 3, p: 2, bgcolor: "#f9fafb", borderRadius: 1 }}>
          <Grid container spacing={2} alignItems="center">
            {filterFields.map((field) => (
              <Grid item xs={12} sm={6} md={4} key={field.label}>
                <TextField
                  label={field.label}
                  placeholder={field.placeholder}
                  size="small"
                  fullWidth
                  disabled
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      ) : null}
      <div className="d-flex justify-content-between align-items-center">
        <TextField
          className="search-field"
          placeholder={searchPlaceholder}
          size="small"
          fullWidth
          disabled
          sx={{ maxWidth: { xs: "100%", sm: 200, md: 250 } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search size={14} />
              </InputAdornment>
            ),
          }}
        />
        {addButtonLabel ? (
          <Button className="add-btn" variant="contained" color="secondary" size="small" disabled>
            {addButtonLabel}
          </Button>
        ) : null}
      </div>
      <div className="mt-1" style={{ height: gridHeight }}>
        {children}
      </div>
    </div>
  );
}
